import { RootState } from '@next/core-lib/app';

import { SettingsDataObject } from '@next/core-lib/settings';

import { FlockState } from '../flock/models/flock.model';

// add your interfaces for the api responses and state here
// SiteState is the root state of your app module
export interface SiteState extends RootState {
  app: AppState;
  flock: FlockState;
}

export interface AppState {
  someValue?: boolean;
}

export interface Product extends SettingsDataObject {
  id: number;
  code: string;
  name: string;
  country?: string;
  isActive: boolean;
  animalType: AnimalType;
  type: ProductType;
  typeDisplay: string;
}

export enum AnimalType {
  Broiler = 'Broiler',
  Layer = 'Layer',
}

export enum ProductType {
  Feed = 'Feed',
  Additive = 'Additive',
}

export enum ViewMode {
  View,
  Create,
  Edit,
}

export enum ApplicationKeys {
  PoultryNextSustainability = 'PoultryNEXTSustainability',
}
